"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _AppUtil = require("../util/AppUtil");
var _ServiceRegistry = _interopRequireDefault(require("../util/ServiceRegistry"));
var _FullScreenIcon = _interopRequireDefault(require("../preview/react-component/icons/full-screen/FullScreenIcon"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
/*************************************************************************
* ADOBE CONFIDENTIAL
* ___________________
*
* Copyright 2019 Adobe
* All Rights Reserved.
*
* NOTICE: All information contained herein is, and remains
* the property of Adobe and its suppliers, if any. The intellectual
* and technical concepts contained herein are proprietary to Adobe
* and its suppliers and are protected by all applicable intellectual
* property laws, including trade secret and copyright laws.
* Dissemination of this information or reproduction of this material
* is strictly forbidden unless prior written permission is obtained
* from Adobe.
**************************************************************************/

class UIHandler {
  initialiseHeaderRef(headerRef) {
    this._headerRef = headerRef;
  }
  getHeight() {
    const config = _ServiceRegistry.default.getService("AppStore").getConfig();
    return config.isViewSDKPublic ? window.innerHeight : (0, _AppUtil.getDOMElement)().clientHeight;
  }
  getWidth() {
    const config = _ServiceRegistry.default.getService("AppStore").getConfig();
    return config.isViewSDKPublic ? window.innerWidth : (0, _AppUtil.getDOMElement)().clientWidth;
  }
  inHoverRangeOfHeaderAndHUD(clientY) {
    const appStore = _ServiceRegistry.default.getService("AppStore");
    if (appStore.isSizedPreset && appStore.inFullScreen) {
      return !appStore.enableModernViewer && (clientY < window.innerHeight * 0.2 || clientY > window.innerHeight * 0.8);
    }
    if (appStore.inFullScreen || appStore.isLBPreset) {
      return clientY < window.innerHeight * 0.2;
    }
    return clientY < this.getHeight();
  }
  showHeaderAndHUD(height) {
    _ServiceRegistry.default.getService("HUDService").showHUD().then(() => {
      if (this._headerRef && this._headerRef.style) {
        const appStore = _ServiceRegistry.default.getService("AppStore");
        if (appStore.enableModernViewer && appStore.inFullScreen) {
          this._headerRef.style.opacity = 1;
        } else {
          this._headerRef.style.opacity = 0.8;
        }
      }
      this.fadeHeaderAndHUD(height);
    });
  }
  fadeHeaderAndHUD(yRange) {
    const appStore = _ServiceRegistry.default.getService("AppStore");
    if (this._fadeTimeout) {
      clearInterval(this._fadeTimeout);
    }
    if (appStore.enableModernViewer && appStore.inFullScreen) {
      return;
    }
    this._fadeTimeout = setInterval(() => {
      const height = this.getHeight();
      const headInRange = yRange < 48;
      const hudInRange = yRange < height && yRange > height - 48;
      if (!(headInRange || hudInRange) && !appStore.searchOpen && !appStore.sideMenuOpen) {
        _ServiceRegistry.default.getService("HUDService").fadeHUD().then(() => {
          if (this._headerRef && this._headerRef.style) {
            this._headerRef.style.opacity = 0;
          }
          clearInterval(this._fadeTimeout);
        });
      }
    }, 3000);
  }
  initialiseBrandingLabelRef(brandingLabelRef) {
    this._brandingLabelRef = brandingLabelRef;
  }
  inHoverRangeOfBrandingLabel(clientY, clientX) {
    return clientY > window.innerHeight * 0.8 && clientX > window.innerWidth * 0.8;
  }
  showBrandingLabel(height, width) {
    if (this._brandingLabelRef && this._brandingLabelRef.style) {
      this._brandingLabelRef.style.opacity = 0.8;
      this._brandingLabelRef.style.display = "flex";
      this.fadeBrandingLabel(height, width);
    }
  }
  fadeBrandingLabel(yRange, xRange) {
    if (this._brandingFadeTimeout) {
      clearInterval(this._brandingFadeTimeout);
    }
    this._brandingFadeTimeout = setInterval(() => {
      const height = this.getHeight();
      const width = this.getWidth();
      const brandingLabelInRange = yRange < height && yRange > height - 80 && xRange < width && xRange > width - 200;
      if (!brandingLabelInRange && this._brandingLabelRef && this._brandingLabelRef.style) {
        this._brandingLabelRef.style.opacity = 0;
        clearInterval(this._brandingFadeTimeout);
      }
    }, 5000);
  }
  updateFSIconInHud() {
    const appStore = _ServiceRegistry.default.getService("AppStore");
    const previewRef = appStore.previewRef;
    if (previewRef && appStore.getActionConfig("preview").showFullScreenInHUD) {
      previewRef.getPublicApis().then(api => {
        if (appStore.fullScreenIdInHUD !== undefined) {
          api.hud.removeUIControl(appStore.fullScreenIdInHUD);
        }
        if (appStore.configStore.showFullScreen && !appStore.inFullScreen) {
          const fsIconAlignment = appStore.enableModernViewer ? "CENTER" : "RIGHT";
          appStore.fullScreenIdInHUD = api.hud.addUIControl(_FullScreenIcon.default, fsIconAlignment);
        }
      });
    }
  }
}
exports.default = UIHandler;